export * from './loading-bar.component';
export * from './loading-bar.module';
